// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file contract_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ContractCreateSchema, ContractListSchema, ContractSchema, ContractUpdateSchema } from "./contract_pb";
import { file_contract } from "./contract_pb";
import type { File, FileJson } from "./file_upload_pb";
import { file_file_upload } from "./file_upload_pb";
import type { ListFilter, ListFilterJson, MessageResponseSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file contract_service.proto.
 */
export const file_contract_service: GenFile = /*@__PURE__*/
  fileDesc("ChZjb250cmFjdF9zZXJ2aWNlLnByb3RvEglyYWNjb29uYWki6AIKE0NvbnRyYWN0TGlzdFJlcXVlc3QSMgoUc2VydmljZV9wcm92aWRlcl9pZHMYASADKARSFHNlcnZpY2VfcHJvdmlkZXJfaWRzEjgKF3RhcmdldF9vcmdhbml6YXRpb25faWRzGAIgAygEUhd0YXJnZXRfb3JnYW5pemF0aW9uX2lkcxIOCgZzdGF0dXMYAyABKAkSDAoEdHlwZRgEIAEoCRIuChJwaWNrdXBfbG9jYXRpb25faWQYBSABKARSEnBpY2t1cF9sb2NhdGlvbl9pZBIuChJjb250YWluZXJfZ3JvdXBfaWQYBiABKARSEmNvbnRhaW5lcl9ncm91cF9pZBIsChFpbmNsdWRlX2FuY2VzdG9ycxgHIAEoCFIRaW5jbHVkZV9hbmNlc3RvcnMSNwoLbGlzdF9maWx0ZXIYCiABKAsyFS5yYWNjb29uYWkuTGlzdEZpbHRlclILbGlzdF9maWx0ZXIihwEKD0NvbnRyYWN0UmVxdWVzdBIKCgJpZBgBIAIoBBIwChNzZXJ2aWNlX3Byb3ZpZGVyX2lkGAIgAigEUhNzZXJ2aWNlX3Byb3ZpZGVyX2lkEjYKFnRhcmdldF9vcmdhbml6YXRpb25faWQYAyACKARSFnRhcmdldF9vcmdhbml6YXRpb25faWQiXgoaVXBsb2FkQ29udHJhY3RGaWxlc1JlcXVlc3QSIAoLY29udHJhY3RfaWQYASACKARSC2NvbnRyYWN0X2lkEh4KBWZpbGVzGAIgAygLMg8ucmFjY29vbmFpLkZpbGUiWgoaRGVsZXRlQ29udHJhY3RGaWxlc1JlcXVlc3QSIAoLY29udHJhY3RfaWQYASACKARSC2NvbnRyYWN0X2lkEhoKCGZpbGVfaWRzGAIgAygEUghmaWxlX2lkczKQBAoPQ29udHJhY3RTZXJ2aWNlEkAKDkNyZWF0ZUNvbnRyYWN0EhkucmFjY29vbmFpLkNvbnRyYWN0Q3JlYXRlGhMucmFjY29vbmFpLkNvbnRyYWN0Ej4KC0dldENvbnRyYWN0EhoucmFjY29vbmFpLkNvbnRyYWN0UmVxdWVzdBoTLnJhY2Nvb25haS5Db250cmFjdBJACg5VcGRhdGVDb250cmFjdBIZLnJhY2Nvb25haS5Db250cmFjdFVwZGF0ZRoTLnJhY2Nvb25haS5Db250cmFjdBJICg1MaXN0Q29udHJhY3RzEh4ucmFjY29vbmFpLkNvbnRyYWN0TGlzdFJlcXVlc3QaFy5yYWNjb29uYWkuQ29udHJhY3RMaXN0EkIKD0FyY2hpdmVDb250cmFjdBIaLnJhY2Nvb25haS5Db250cmFjdFJlcXVlc3QaEy5yYWNjb29uYWkuQ29udHJhY3QSWAoTRGVsZXRlQ29udHJhY3RGaWxlcxIlLnJhY2Nvb25haS5EZWxldGVDb250cmFjdEZpbGVzUmVxdWVzdBoaLnJhY2Nvb25haS5NZXNzYWdlUmVzcG9uc2USUQoTVXBsb2FkQ29udHJhY3RGaWxlcxIlLnJhY2Nvb25haS5VcGxvYWRDb250cmFjdEZpbGVzUmVxdWVzdBoTLnJhY2Nvb25haS5Db250cmFjdEIGWgQuL3Bi", [file_contract, file_file_upload, file_general]);

/**
 * Contract Requests - either service provider or target organization can request contract details
 *
 * @generated from message raccoonai.ContractListRequest
 */
export type ContractListRequest = Message<"raccoonai.ContractListRequest"> & {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  serviceProviderIds: bigint[];

  /**
   * @generated from field: repeated uint64 target_organization_ids = 2 [json_name = "target_organization_ids"];
   */
  targetOrganizationIds: bigint[];

  /**
   * @generated from field: optional string status = 3;
   */
  status: string;

  /**
   * @generated from field: optional string type = 4;
   */
  type: string;

  /**
   * @generated from field: optional uint64 pickup_location_id = 5 [json_name = "pickup_location_id"];
   */
  pickupLocationId: bigint;

  /**
   * @generated from field: optional uint64 container_group_id = 6 [json_name = "container_group_id"];
   */
  containerGroupId: bigint;

  /**
   * Also the contracts of the providers' ancestors, so a child organization sees its parent's contracts.
   *
   * @generated from field: optional bool include_ancestors = 7 [json_name = "include_ancestors"];
   */
  includeAncestors: boolean;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * Contract Requests - either service provider or target organization can request contract details
 *
 * @generated from message raccoonai.ContractListRequest
 */
export type ContractListRequestJson = {
  /**
   * @generated from field: repeated uint64 service_provider_ids = 1 [json_name = "service_provider_ids"];
   */
  service_provider_ids?: string[];

  /**
   * @generated from field: repeated uint64 target_organization_ids = 2 [json_name = "target_organization_ids"];
   */
  target_organization_ids?: string[];

  /**
   * @generated from field: optional string status = 3;
   */
  status?: string;

  /**
   * @generated from field: optional string type = 4;
   */
  type?: string;

  /**
   * @generated from field: optional uint64 pickup_location_id = 5 [json_name = "pickup_location_id"];
   */
  pickup_location_id?: string;

  /**
   * @generated from field: optional uint64 container_group_id = 6 [json_name = "container_group_id"];
   */
  container_group_id?: string;

  /**
   * Also the contracts of the providers' ancestors, so a child organization sees its parent's contracts.
   *
   * @generated from field: optional bool include_ancestors = 7 [json_name = "include_ancestors"];
   */
  include_ancestors?: boolean;

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.ContractListRequest.
 * Use `create(ContractListRequestSchema)` to create a new message.
 */
export const ContractListRequestSchema: GenMessage<ContractListRequest, {jsonType: ContractListRequestJson}> = /*@__PURE__*/
  messageDesc(file_contract_service, 0);

/**
 * @generated from message raccoonai.ContractRequest
 */
export type ContractRequest = Message<"raccoonai.ContractRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  serviceProviderId: bigint;

  /**
   * @generated from field: required uint64 target_organization_id = 3 [json_name = "target_organization_id"];
   */
  targetOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ContractRequest
 */
export type ContractRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 service_provider_id = 2 [json_name = "service_provider_id"];
   */
  service_provider_id?: string;

  /**
   * @generated from field: required uint64 target_organization_id = 3 [json_name = "target_organization_id"];
   */
  target_organization_id?: string;
};

/**
 * Describes the message raccoonai.ContractRequest.
 * Use `create(ContractRequestSchema)` to create a new message.
 */
export const ContractRequestSchema: GenMessage<ContractRequest, {jsonType: ContractRequestJson}> = /*@__PURE__*/
  messageDesc(file_contract_service, 1);

/**
 * @generated from message raccoonai.UploadContractFilesRequest
 */
export type UploadContractFilesRequest = Message<"raccoonai.UploadContractFilesRequest"> & {
  /**
   * @generated from field: required uint64 contract_id = 1 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: repeated raccoonai.File files = 2;
   */
  files: File[];
};

/**
 * @generated from message raccoonai.UploadContractFilesRequest
 */
export type UploadContractFilesRequestJson = {
  /**
   * @generated from field: required uint64 contract_id = 1 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: repeated raccoonai.File files = 2;
   */
  files?: FileJson[];
};

/**
 * Describes the message raccoonai.UploadContractFilesRequest.
 * Use `create(UploadContractFilesRequestSchema)` to create a new message.
 */
export const UploadContractFilesRequestSchema: GenMessage<UploadContractFilesRequest, {jsonType: UploadContractFilesRequestJson}> = /*@__PURE__*/
  messageDesc(file_contract_service, 2);

/**
 * @generated from message raccoonai.DeleteContractFilesRequest
 */
export type DeleteContractFilesRequest = Message<"raccoonai.DeleteContractFilesRequest"> & {
  /**
   * @generated from field: required uint64 contract_id = 1 [json_name = "contract_id"];
   */
  contractId: bigint;

  /**
   * @generated from field: repeated uint64 file_ids = 2 [json_name = "file_ids"];
   */
  fileIds: bigint[];
};

/**
 * @generated from message raccoonai.DeleteContractFilesRequest
 */
export type DeleteContractFilesRequestJson = {
  /**
   * @generated from field: required uint64 contract_id = 1 [json_name = "contract_id"];
   */
  contract_id?: string;

  /**
   * @generated from field: repeated uint64 file_ids = 2 [json_name = "file_ids"];
   */
  file_ids?: string[];
};

/**
 * Describes the message raccoonai.DeleteContractFilesRequest.
 * Use `create(DeleteContractFilesRequestSchema)` to create a new message.
 */
export const DeleteContractFilesRequestSchema: GenMessage<DeleteContractFilesRequest, {jsonType: DeleteContractFilesRequestJson}> = /*@__PURE__*/
  messageDesc(file_contract_service, 3);

/**
 * @generated from service raccoonai.ContractService
 */
export const ContractService: GenService<{
  /**
   * @generated from rpc raccoonai.ContractService.CreateContract
   */
  createContract: {
    methodKind: "unary";
    input: typeof ContractCreateSchema;
    output: typeof ContractSchema;
  },
  /**
   * @generated from rpc raccoonai.ContractService.GetContract
   */
  getContract: {
    methodKind: "unary";
    input: typeof ContractRequestSchema;
    output: typeof ContractSchema;
  },
  /**
   * @generated from rpc raccoonai.ContractService.UpdateContract
   */
  updateContract: {
    methodKind: "unary";
    input: typeof ContractUpdateSchema;
    output: typeof ContractSchema;
  },
  /**
   * @generated from rpc raccoonai.ContractService.ListContracts
   */
  listContracts: {
    methodKind: "unary";
    input: typeof ContractListRequestSchema;
    output: typeof ContractListSchema;
  },
  /**
   * @generated from rpc raccoonai.ContractService.ArchiveContract
   */
  archiveContract: {
    methodKind: "unary";
    input: typeof ContractRequestSchema;
    output: typeof ContractSchema;
  },
  /**
   * @generated from rpc raccoonai.ContractService.DeleteContractFiles
   */
  deleteContractFiles: {
    methodKind: "unary";
    input: typeof DeleteContractFilesRequestSchema;
    output: typeof MessageResponseSchema;
  },
  /**
   * @generated from rpc raccoonai.ContractService.UploadContractFiles
   */
  uploadContractFiles: {
    methodKind: "unary";
    input: typeof UploadContractFilesRequestSchema;
    output: typeof ContractSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_contract_service, 0);

